import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { VehiclesService } from 'src/app/services/vehicles.service';
import { AppComponent } from 'src/app/app.component';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { PlatformService } from 'src/app/platform.service';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.page.html',
  styleUrls: ['./vehicles.page.scss'],
})
export class VehiclesPage implements OnDestroy {
  subscriptionEvent;
 
  constructor(
    private errorhandlerSRV:ErrorHandlerService,
    public platformSRV:PlatformService,
    private errorSRV:ErrorHandlerService,
    public appComp:AppComponent,
    public modalController: ModalController,
    public dataService: DataService,
    public vehiclesSRV:VehiclesService,
   
  ) {}
  
  ionViewDidEnter() {
    this.subscriptionEvent = this.dataService.isAuthenticated.subscribe(isLoggedIn=>{
      if(isLoggedIn){
        this.loadData()
      } else {
        this.vehiclesSRV.loaded=false;
        this.vehiclesSRV.vehicles={}
        this.ngOnDestroy()
      }
    })
    
  }
  
  ngOnDestroy() {
    if(this.subscriptionEvent){
      this.subscriptionEvent.unsubscribe()
    }
     
   }
  loadData(){
    this.dataService.getData('api/v1/user/vehicles').subscribe({
      next:(data:any)=>{
        if(data['status']=="success"){
          this.vehiclesSRV.vehicles=data?.vehicles
          this.vehiclesSRV.provinces=this.dataService.sortProvincesByCountry(data?.provinces)
          this.vehiclesSRV.colours=data?.colours
          this.vehiclesSRV.makes=data?.makes
          this.vehiclesSRV.plateTypes=data?.plateTypes
          this.vehiclesSRV.types=data?.types
        }
        else {
          this.ngOnDestroy()
          return
          
        }
        this.vehiclesSRV.loaded=true
      },
      error:error=>{
        this.errorhandlerSRV.displayErrorMessage(error,true)
        this.ngOnDestroy()
      }
      
      
      
    })
  }


  

  
}
